<template>
  <b-modal
    v-model="showModal"
    centered
    header-class="custom-modal-header"
    footer-class="custom-modal-footer"
  >
    <template #modal-header>
      <p class="text-header">Setting</p>
    </template>
    <b-form>
      <div v-if="form.id == 6">
        <InputText
          v-model="form.clientId"
          textFloat="Client ID"
          placeholder="Client ID"
          isRequired
          :isValidate="$v.form.clientId.$error"
          :v="$v.form.clientId"
          type="text"
        />
        <InputText
          v-model="form.userId"
          textFloat="User ID"
          placeholder="User ID"
          type="text"
          class="mt-2"
          isRequired
          :isValidate="$v.form.userId.$error"
          :v="$v.form.userId"
        />
        <InputText
          v-model="form.tenantId"
          textFloat="Tenant ID"
          placeholder="Tenant ID"
          type="text"
          class="mt-2"
          isRequired
          :isValidate="$v.form.tenantId.$error"
          :v="$v.form.tenantId"
        />
        <InputText
          v-model="form.clientSecret"
          textFloat="Client Secret"
          placeholder="Client Secret"
          type="text"
          class="mt-2"
          isRequired
          :isValidate="$v.form.clientSecret.$error"
          :v="$v.form.clientSecret"
        />
      </div>
      <div v-else>
        <InputText
          v-model="form.url"
          textFloat="URL"
          placeholder="URL"
          isRequired
          :isValidate="$v.form.url.$error"
          :v="$v.form.url"
          type="text"
        />
        <InputText
          v-model="form.token"
          textFloat="Token"
          placeholder="Token"
          type="text"
          class="mt-2"
          isRequired
          :isValidate="$v.form.token.$error"
          :v="$v.form.token"
        />
      </div>
    </b-form>
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-between">
        <button
          :disabled="isLoading"
          class="cancel-button"
          @click="onCloseModal()"
        >
          Cancel
        </button>
        <button :disabled="isLoading" class="save-button" @click="onSubmit()">
          Save
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import { url, requiredIf } from "vuelidate/lib/validators";

export default {
  name: "ModalSettingPlugin",
  components: {
    InputText,
  },
  validations() {
    return {
      form: {
        url: {
          required: requiredIf((item) => item.id == 0 || item.id == 5),
          url,
        },
        token: { required: requiredIf((item) => item.id == 0 || item.id == 5) },
        clientId: { required: requiredIf((item) => item.id == 6) },
        userId: { required: requiredIf((item) => item.id == 6) },
        tenantId: { required: requiredIf((item) => item.id == 6) },
        clientSecret: { required: requiredIf((item) => item.id == 6) },
      },
    };
  },
  data: function () {
    return {
      showModal: false,
      isLoading: false,
      form: {
        id: 0,
        type: 0,
        url: "",
        token: "",
        status: 0,
        brandId: 0,
        clientId: "",
        userId: "",
        tenantId: "",
        clientSecret: "",
      },
    };
  },
  methods: {
    onShowModal: async function (item = false) {
      this.$v.$reset();
      if (item) this.form = { ...item };
      else this.setDefaultData();

      this.form.brandId = this.$route.query.brandID;
      this.showModal = true;
    },
    setDefaultData() {
      this.form = {
        id: 0,
        type: 0,
        url: "",
        token: "",
        status: 0,
        brandId: 0,
        clientId: "",
        userId: "",
        tenantId: "",
        clientSecret: "",
      };
    },
    onCloseModal() {
      this.showModal = false;
    },
    onSubmit: async function () {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;

      this.isLoading = true;
      await this.$store.commit("UPDATE_MAIN_LOADING", true);
      await this.axios
        .post(`${this.$baseUrl}/ThirdParty/Update`, this.form)
        .then(async (data) => {
          await this.$store.commit("UPDATE_MAIN_LOADING", false);
          if (data.result == 1) {
            this.$store.commit("UPDATE_GLOBAL_ALERT", {
              isShow: true,
              msg: "",
            });
            this.$emit("reloadData");
            this.onCloseModal();
          } else {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
          }
        });
      this.isLoading = false;
    },
  },
};
</script>
